import React, { useCallback, useEffect, useState } from "react";
import { httpsCallable } from "firebase/functions";
import Banner from "../components/Header-Loged";
import { functions } from "../firebase";
import "../css/BlockedContacts.css";

const EMPTY = { nombre: "", email: "", telefono: "", cuil: "", reason: "" };

export default function BlockedContacts() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editingId, setEditingId] = useState(null);
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadRows = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const list = httpsCallable(functions, "listBlockedContacts");
      const response = await list();
      setRows(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error("Blocked contacts list error", err);
      setError("No se pudo cargar el listado. Verificá que las funciones estén desplegadas.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadRows(); }, [loadRows]);

  const change = (event) =>
    setForm((current) => ({ ...current, [event.target.name]: event.target.value }));

  const save = async (event) => {
    event.preventDefault();
    if (![form.nombre, form.email, form.telefono, form.cuil].some((value) => value.trim())) {
      setError("Ingresá al menos un identificador para bloquear.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      const manage = httpsCallable(functions, "manageBlockedContact");
      await manage({ action: editingId ? "update" : "create", id: editingId, contact: form });
      setForm(EMPTY);
      setEditingId(null);
      await loadRows();
    } catch (err) {
      console.error("Blocked contact save error", err);
      setError("No se pudo guardar el bloqueo.");
    } finally {
      setBusy(false);
    }
  };

  const edit = (row) => {
    setEditingId(row.id);
    setForm({
      nombre: row.nombre || "",
      email: row.email || "",
      telefono: row.telefono || "",
      cuil: row.cuil || "",
      reason: row.reason || "",
    });
  };

  const remove = async (row) => {
    if (!window.confirm("¿Eliminar este contacto y habilitar nuevamente sus identificadores?")) return;
    setBusy(true);
    setError("");
    try {
      const manage = httpsCallable(functions, "manageBlockedContact");
      await manage({ action: "delete", id: row.id });
      if (editingId === row.id) {
        setEditingId(null);
        setForm(EMPTY);
      }
      await loadRows();
    } catch (err) {
      console.error("Blocked contact delete error", err);
      setError("No se pudo eliminar el bloqueo.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="blocked-page">
      <Banner />
      <main className="blocked-content">
        <h1>Contactos bloqueados</h1>
        <p>Los datos permanecen bloqueados hasta que un administrador elimina el registro.</p>
        <form className="blocked-form" onSubmit={save}>
          <input name="nombre" value={form.nombre} onChange={change} placeholder="Nombre completo" />
          <input name="email" value={form.email} onChange={change} placeholder="Correo electrónico" />
          <input name="telefono" value={form.telefono} onChange={change} placeholder="Teléfono" />
          <input name="cuil" value={form.cuil} onChange={change} placeholder="CUIL/DNI" />
          <input name="reason" value={form.reason} onChange={change} placeholder="Motivo" />
          <button type="submit" disabled={busy}>{editingId ? "Guardar cambios" : "Agregar bloqueo"}</button>
          {editingId && <button type="button" onClick={() => { setEditingId(null); setForm(EMPTY); }}>Cancelar</button>}
        </form>
        {error && <p className="blocked-error" role="alert">{error}</p>}
        <div className="blocked-table-wrap">
          <table className="blocked-table">
            <thead><tr><th>Nombre</th><th>Email</th><th>Teléfono</th><th>CUIL/DNI</th><th>Origen / motivo</th><th>Acciones</th></tr></thead>
            <tbody>
              {loading && <tr><td colSpan="6">Cargando contactos bloqueados…</td></tr>}
              {!loading && rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.nombre || "—"}</td><td>{row.email || "—"}</td><td>{row.telefono || "—"}</td>
                  <td>{row.cuil || "—"}</td><td>{row.origin || "—"} · {row.reason || "—"}</td>
                  <td><button type="button" onClick={() => edit(row)}>Editar</button> <button type="button" onClick={() => remove(row)} disabled={busy}>Eliminar</button></td>
                </tr>
              ))}
              {!loading && !rows.length && <tr><td colSpan="6">No hay contactos bloqueados.</td></tr>}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}
